import "@suse-o11y/legacy/styles.css";
import "@suse-o11y/legacy/antd.less";

import "@suse-o11y/legacy/main/generic/polyfills";

import { createReduxStore } from "@suse-o11y/legacy/main/app/state/ReduxStore";
import { MaintenanceBoundary } from "@suse-o11y/legacy/main/components/maintenance-boundary";
import {
	DEFAULT_QUERY_CLIENT_CONFIG,
	QueryClient,
	QueryClientProvider,
} from "@suse-o11y/legacy/main/queries/react-query";
import { Root } from "@suse-o11y/legacy/main/Root";
import { AnalyticsProvider } from "@suse-o11y/legacy/tools/analytics/provider";
import { createHashHistory } from "history";
import { enableMapSet } from "immer";
import React from "react";
import { createRoot } from "react-dom/client";

enableMapSet();

// biome-ignore lint/style/noRestrictedGlobals: legacy
(window as { startTime?: number }).startTime = performance.now();

const queryClient = new QueryClient(DEFAULT_QUERY_CLIENT_CONFIG);
const history = createHashHistory();
const store = createReduxStore({ queryClient, history });

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
	<QueryClientProvider client={queryClient}>
		<AnalyticsProvider>
			<MaintenanceBoundary>
				<Root history={history} store={store} />
			</MaintenanceBoundary>
		</AnalyticsProvider>
	</QueryClientProvider>,
);
